import { selectCompletedMatches } from "selectors/Match";
import {
  selectTournamentMatchIds,
  selectTournamentTracks,
} from "selectors/Tournament";
import { StatTable } from "components/StatsTable/StatTable";
import { useNavigate } from "react-router-dom";
import { buildTrackPath } from "pages/PageConfigs";
import { getSharedTracksStats } from "stats/Tracks/SharedTracksStats";
import { SharedTracksStatTableColumns } from "components/StatsTable/ColumnConfigs/Tracks/Shared";
import { useAppSelector } from "app/hooks";
import { shallowEqual } from "react-redux";

interface Props {
  tournamentId: string;
}

export const TrackList = ({ tournamentId }: Props) => {
  const navigate = useNavigate();
  const tracks = useAppSelector(
    (state) => selectTournamentTracks(state, tournamentId) ?? []
  );

  const completeMatches = useAppSelector((state) => {
    const matchIds = selectTournamentMatchIds(state, tournamentId);
    return !!matchIds ? selectCompletedMatches(state, matchIds) : [];
  }, shallowEqual);

  const stats = tracks.map(({ id, name }) =>
    getSharedTracksStats(completeMatches, id, name)
  );

  return (
    <StatTable
      stats={stats}
      keyGetter={(stat) => stat.trackId}
      columns={SharedTracksStatTableColumns}
      onRowClick={(stat) => navigate(buildTrackPath(stat.trackId))}
      initialSortColumnIdx={0}
    />
  );
};
